import { compose, not, pathOr } from 'ramda';
import { Loading } from '@fasstech/middle-design-system';
import SouscriptionRecapForm from './SouscriptionRecapForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import withGlobalData from '@@viewCommonHoc/withGlobalData';
import useGetSouscriptionRecapQuery from './hooks/useGetSouscriptionRecapQuery';

const SouscriptionRecap = ({
  getMiddleText,
  getMiddleBoolean,
  middleFeatures,
  familySituations,
  regimeObligatoire,
  professionalSituations,
  socioProfessionalCategories,
  activities,
  viewMode,
  usersInformation
}) => {
  const {
    getSouscriptionRecap,
    loading,
    error
  } = useGetSouscriptionRecapQuery();

  //TODO Display en error instead of infinite loading

  const isNotReady = loading || error;

  if (isNotReady || not(familySituations) || not(regimeObligatoire)) return <Loading/>;

  return (
    <SouscriptionRecapForm
      project={getSouscriptionRecap}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      middleFeatures={middleFeatures}
      familySituations={familySituations}
      regimeObligatoire={regimeObligatoire}
      jobs={pathOr([], ['jobs'], getSouscriptionRecap)}
      professionalSituations={professionalSituations}
      socioProfessionalCategories={socioProfessionalCategories}
      activities={activities}
      viewMode={viewMode}
      usersInformation={usersInformation}
    />
  );
};

export default compose(withMiddleFeatures, withGlobalData)(SouscriptionRecap);
